import { useCallback, useEffect, useState } from "react";
import { getAsignacionesModems } from "../services/reqSolicitudes";

const extractItems = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.items)) return data.items;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.data?.items)) return data.data.items;
  return [];
};

export function useAsignacionesModems(cod) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetch = useCallback(async () => {
    try {
      setLoading(true);
      const resp = await getAsignacionesModems(cod);
      setItems(extractItems(resp?.data));
    } finally {
      setLoading(false);
    }
  }, [cod]);

  useEffect(() => { fetch(); }, [fetch]);

  return { items, loading, refetch: fetch };
}
